import { FC } from "react";
import { FactorActivityDataWithType, FactorActivityUpdate } from "../types";
import {
  ActivityBody,
  ActivityBodyInfo,
  ActivityBy,
  ActivityDate,
  ActivityFooter,
  ActivityTitle,
} from "../../components";
import { addComma } from "../../../../utils";

const FactorUpdateActivity: FC<FactorActivityDataWithType> = ({
  activity,
  by,
  date,
  type,
}) => {
  const activity_ = activity as FactorActivityUpdate;
  return (
    <>
      <ActivityTitle type={type}>ویرایش فاکتور</ActivityTitle>
      <ActivityBody>
        <ActivityBodyInfo
          type={type}
          title="بابت"
          value={activity_.description}
        />
        <ActivityBodyInfo
          type={type}
          title="مبلغ فاکتور"
          value={addComma(activity_.total_price)}
        />
      </ActivityBody>
      <ActivityFooter>
        <ActivityBy>{by}</ActivityBy>
        <ActivityDate>{date}</ActivityDate>
      </ActivityFooter>
    </>
  );
};

export default FactorUpdateActivity;
